import { SET_RECOMMENDED_PRODUCTS } from "../actions/recommendedAction";

const recommendedReducer = (state = [], action) => {
  switch (action.type) {
    case SET_RECOMMENDED_PRODUCTS:
      return action.payload;
    default:
      return state;
  }
};

export default recommendedReducer;
